import { CreateToolbar, MapToolType } from "../createToolbar";

export class ToolbarIssuePointHandler {
    constructor(private toolbar: CreateToolbar) {}

    handle = (idElement: string) => {
        this.toolbar.isShowModalIssuePoint = !this.toolbar.isShowModalIssuePoint;
        if (this.toolbar.isShowModalIssuePoint) {
            this.toolbar.deactivateOtherTools(MapToolType.ISSUE_POINT);
        }

        this.toolbar.issuePoint!.setClosedCallback((status: boolean) => {
            if (!status) {
                this.toolbar.isShowModalIssuePoint = false;
            }
        });
    };
}
